import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Audience from './icon-audience.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Audience {...validProps} />;
}
SvgComponent.iconName = 'audience';

/**
 * @deprecated This is a legacy icon
 */
export const AudienceIcon = svgIconWrapper(SvgComponent);
